<template>
  <el-dialog
    :title="'选择子公司'"
    :close-on-click-modal="false"
    class="abow_dialog"
    width="50%"
    :visible.sync="visible">
    <el-form  size="mini" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px" style="margin: 20px 0" class="user-info-dialog-form">
      <el-form-item label="子公司名称" prop="selectedDataSource">
        <el-radio-group v-model="dataForm.selectedDataSource">
          <div style="display: flex; flex-wrap: wrap;">
            <el-radio
                :label="item.id"
                v-for="(item) in datasource"
                :key="item.id"        style="flex: 0 0 40%; max-width: 40%;">
              {{ item.orgName }}
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="small" @click="visible = false">取消</el-button>
        <el-button type="primary" size="small" @click="dataFormSubmit()" :loading="dataFormSubmitLoading">创建</el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import {selectSupplierById,updateSupplierById,createDisposableSupplier} from '@/controller/supplier'
  import {enableGroupSupplier} from "../../../../controller/supplier";
  
  export default {
    data () {
      
      return {
        datasource: [
        ],
        dataFormSubmitLoading:false,
        visible: false,
        // 用于存储form 中的数据
        dataForm: {
          id: 0,
          selectedDataSource: '',
        },
        dataRule: {},
      }
    },
    methods: {
      init (row) {
        this.visible = true
        this.dataForm.id = row.id || 0
        this.datasource = row.supCompanyList
        this.supplierLevel = row.supplierLevel
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          selectSupplierById(
                    {id : this.dataForm.id}
             ).then(data => {
               if (data && data.code === '00') {
                 this.dataForm = {...this.dataForm, ...data.body}
               }
             })

          })
      },
      
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.dataFormSubmitLoading = true
            enableGroupSupplier({
              "subcompanyId":this.dataForm.selectedDataSource,
              "supId":this.dataForm.id,
              "supplierLevel":this.dataForm.supplierLevel
            }).then(resSub=>{
              if(resSub && resSub.code === '00') {
                this.visible = false
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.getDataList()
                  }
                })
              }
              else {
                this.$message.error(resSub.msg)
              }
            }).catch((e) => {this.dataFormSubmitLoading = false}).finally(()=>{
                this.dataFormSubmitLoading = false
              })

          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>